import React from 'react';
import { FONTE_TEXTO } from '../paleta';

/**
 * Padrão de `<select>` do protótipo: wrapper relativo + select com appearance none +
 * chevron `⌄` absoluto (espelho do bloco repetido em `sistema/index.html`, ex. linhas
 * 87-95). As variações de padding/cor/largura entre os usos são passadas por props de
 * estilo, com os MESMOS valores literais do protótipo em cada ponto de uso.
 */

export interface OpcaoSelect {
  value: string;
  label: string;
}

interface SelectFiltroProps {
  value: string;
  onChange: (novo: string) => void;
  opcoes: OpcaoSelect[];
  /** Estilo do select — mesclado sobre a base comum do protótipo. */
  selectStyle?: React.CSSProperties;
  /** Estilo do chevron — mesclado sobre a base (right 10px, 10px, cinza). */
  chevronStyle?: React.CSSProperties;
  /** Estilo do wrapper relativo (ex.: `flex: 1 1 220px` nos formulários). */
  wrapperStyle?: React.CSSProperties;
}

export const SelectFiltro: React.FC<SelectFiltroProps> = ({
  value,
  onChange,
  opcoes,
  selectStyle,
  chevronStyle,
  wrapperStyle,
}) => (
  <div
    style={{ position: 'relative', display: 'flex', alignItems: 'center', ...(wrapperStyle ?? {}) }}
  >
    <select
      onChange={ev => onChange(ev.target.value)}
      value={value}
      style={{
        appearance: 'none',
        padding: '7px 30px 7px 12px',
        borderRadius: '8px',
        border: '1px solid oklch(0.9 0.006 160)',
        background: 'oklch(1 0 0)',
        fontFamily: FONTE_TEXTO,
        fontSize: '12.5px',
        fontWeight: 600,
        color: 'oklch(0.3 0.02 165)',
        cursor: 'pointer',
        ...(selectStyle ?? {}),
      }}
    >
      {opcoes.map(op => (
        <option key={op.value} value={op.value}>
          {op.label}
        </option>
      ))}
    </select>
    <span
      style={{
        position: 'absolute',
        right: '10px',
        pointerEvents: 'none',
        fontSize: '10px',
        color: 'oklch(0.5 0.015 165)',
        ...(chevronStyle ?? {}),
      }}
    >
      ⌄
    </span>
  </div>
);
